export default __webpack_public_path__ + "static/media/minio_console_logo.0837460e.svg";